import { Box, useTheme } from '@mui/material';
import { useAppUI } from 'src/context/AppUIProvider/useAppUI';
import ExpandableAlert from 'src/components/ExpandableAlert';
import { useLocation } from 'react-router-dom';

const ALLOWED_ROUTES = [
  '/',
  '/products',
  '/promociones',
  '/categories',
  '/categories/:categorySlug/products',
];

const HeaderAlert = () => {
  const theme = useTheme();
  const { isMobile, statusBar, headerAlertProps } = useAppUI();
  const { pathname } = useLocation();

  const isAllowedRoute = ALLOWED_ROUTES.some((route) => {
    if (route.includes(':categorySlug')) {
      return pathname.match(/^\/categories\/[^/]+\/products$/);
    }
    return pathname === route;
  });

  if (!headerAlertProps || !isAllowedRoute) return null;

  const toolbarHeight = isMobile ? 56 : 64;

  const paddingTop = isMobile ? (statusBar?.visible ? 32 : 12) : 0;

  const paddingBottom = 4;

  const topOffset = toolbarHeight + paddingTop + paddingBottom;

  return (
    <Box
      sx={{
        position: 'sticky',
        top: topOffset,
        zIndex: theme.zIndex.appBar,
        width: '100%',
      }}
    >
      <ExpandableAlert
        title={headerAlertProps.title}
        description={headerAlertProps.description}
        color="primary"
        sx={{
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
        }}
      />
    </Box>
  );
};

export default HeaderAlert;
